// extracted by mini-css-extract-plugin
export var chevronIcon = "_4o-2";
export var teamName = "_4o-1";
export var teamSwitcherButton = "_4o-0";